<template>
  <div>
    <b-button @click="initiateAddBeneficiaire()" class="mb-2" variant="success" :hidden="cantEditFicheDC(dossier)"><i class="fa fa-plus"></i> Ajouter un bénéficiaire</b-button>
    <v-client-table id="table-beneficiaire" ref="table-beneficiaire" :columns="columns" :data="items" :options="options">
      <div slot="action" slot-scope="props" :hidden="cantEditFicheDC(dossier)">
        <i class="fa fa-edit mr-2 text-primary fa-1_5x clickable" @click="editBeneficiaire(props.row)"></i>
        <i v-if="!isDisabled('suppressionBeneficiaire')" class="fa fa-trash text-danger clickable" @click="deleteBeneficiaire(props.row.id)"></i>
      </div>
      <div slot="lien_parente" slot-scope="props" v-html="!isEmpty(props.row.lien_parente) ? props.row.lien_parente.libelle : ''">
      </div>
      <div slot="date_naissance" slot-scope="props" class="slot-date">
        {{ formatDate(props.row.date_naissance) }}
      </div>
      <div v-if="props.row.status_id" slot="status" slot-scope="props" class="">
        {{ getStatusLibelle(props.row) }}
      </div>
      <div slot="capital_deces" slot-scope="props" v-html="getCapitalDecesLibelle(props.row)"></div>
      <div slot="rentes" slot-scope="props" v-html="getRentesLibelle(props.row)"></div>
      <div slot="allocations" slot-scope="props" v-html="getAllocationsLibelle(props.row)"></div>

      <div v-if="props.row.date_status" slot="date_status" slot-scope="props" class="slot-date">
        {{ formatDate(props.row.date_status) }}
      </div>
      <div v-if="props.row.date_capital_deces_transmis" slot="date_capital_deces_transmis" slot-scope="props" class="slot-date">
        {{ formatDate(props.row.date_capital_deces_transmis) }}
      </div>
      <div v-if="props.row.date_rentes_transmis" slot="date_rentes_transmis" slot-scope="props" class="slot-date">
        {{ formatDate(props.row.date_rentes_transmis) }}
      </div>
      <div v-if="props.row.date_allocations_transmis" slot="date_allocations_transmis" slot-scope="props" class="slot-date">
        {{ formatDate(props.row.date_allocations_transmis) }}
      </div>
    </v-client-table>

    <b-card no-body v-if="showCardInfosBeneficiaire">
      <div class="card-smallHeader card-header-action" v-b-toggle.collapse-completude-document>
                    <span><b>Infos bénéficiaire</b></span>
        <div class="card-header-actions">
                <span class="when-opened">
                        <i class="icon-arrow-down"></i>
                      </span>
          <span class="when-closed">
                  <i class="icon-arrow-up"></i>
                </span>
        </div>
      </div>
      <b-collapse id="collapse-completude-document" class="m-3 pl-1 pr-1" v-model="collapseInfosBeneficiaire" :class="collapseInfosBeneficiaire ? null : 'collapsed'">
        <b-card-text class="p-1">
          <b-row>
            <b-col sm="5" style="border-right: 1px solid #ECECEC;">
              <b-row class="mb-1">
                <b-col sm="3">
                  <label for="nom"><strong>Nom : </strong></label>
                </b-col>
                <b-col sm="9">
                    <b-form-input type="text" id="nom" v-model="nom" placeholder="" :class="{hasError: errors.nom !== ''}"></b-form-input>
                    <span class="field-error inline mr-1 float-right">{{ errors.nom }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col sm="3">
                  <label for="prenom"><strong>Prénom : </strong></label>
                </b-col>
                <b-col sm="9">
                    <b-form-input type="text" id="prenom" v-model="prenom" placeholder="" :class="{hasError: errors.prenom !== ''}"></b-form-input>
                    <span class="field-error inline mr-1 float-right">{{ errors.prenom }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col sm="3">
                  <label for="date_naissance"><strong>Date de naissance :</strong></label>
                </b-col>
                <b-col sm="4">
                  <b-form-input class="input_date" type="date" id="date_naissance" size="sm" v-model="date_naissance"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col sm="3">
                  <label for="gestionnaire"><strong>Lien de parenté : </strong></label>
                </b-col>
                <b-col sm="9">
                  <b-form-select v-model="selectedLienParente" :options="lienParenteOptions" :class="{hasError: errors.selectedLienParente !== ''}">
                    <template v-slot:first>
                      <b-form-select-option :value="''" disabled>-- Choisir un lien de parenté --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <span class="field-error inline mr-1 float-right">{{ errors.selectedLienParente }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col sm="3">
                  <label for="adresse1"><strong>Adresse 1 : </strong></label>
                </b-col>
                <b-col sm="9">
                    <b-form-input type="text" id="adresse1" v-model="adresse1" placeholder=""></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col sm="3">
                  <label for="adresse2"><strong>Adresse 2 : </strong></label>
                </b-col>
                <b-col sm="9">
                    <b-form-input type="text" id="adresse2" v-model="adresse2" placeholder=""></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col sm="3">
                  <label for="adresse3"><strong>Adresse 3 : </strong></label>
                </b-col>
                <b-col sm="9">
                    <b-form-input type="text" id="adresse3" v-model="adresse3" placeholder=""></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col sm="3">
                  <label for="code_postal"><strong>Code postal : </strong></label>
                </b-col>
                <b-col sm="2">
                    <b-form-input type="text" id="code_postal" v-model="cp" placeholder=""></b-form-input>
                </b-col>
                <b-col sm="2">
                  <label for="ville"><strong>Ville : </strong></label>
                </b-col>
                <b-col sm="5">
                    <b-form-input type="text" id="ville" v-model="ville" placeholder=""></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col sm="3">
                  <label for="email"><strong>Email : </strong></label>
                </b-col>
                <b-col sm="9">
                    <b-form-input type="text" id="email" v-model="email" placeholder=""></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col sm="3">
                  <label for="telephone"><strong>Téléphone : </strong></label>
                </b-col>
                <b-col sm="9">
                    <b-form-input type="text" id="telephone" v-model="telephone" placeholder=""></b-form-input>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="7">
              <b-row class="mb-1">
                <b-col sm="2">
                  <label for="capitalDeces"><strong>Capital Décès : </strong></label>
                </b-col>
                <b-col sm="5">
                  <multiselect id="capitalDeces" selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false" v-model="capitalDeces" tag-placeholder="Choisissez un status" placeholder="Par défaut Tous" label="name" track-by="code" :options="capitalOptions" :multiple="true" :taggable="true"></multiselect>
                </b-col>
                <b-col sm="2">
                  <label for="date_capital_deces_transmis"><strong>Transmis le : </strong></label>
                </b-col>
                <b-col sm="3">
                  <b-form-input class="input_date" type="date" id="date_capital_deces_transmis" size="sm" v-model="date_capital_deces_transmis"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col sm="2">
                  <label for="rentes"><strong>Rente : </strong></label>
                </b-col>
                <b-col sm="5">
                  <multiselect id="rentes" selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false" v-model="rentes" tag-placeholder="Choisissez un status" placeholder="Par défaut Tous" label="name" track-by="code" :options="rentesOptions" :multiple="true" :taggable="true"></multiselect>
                </b-col>
                <b-col sm="2">
                  <label for="date_rentes_transmis"><strong>Transmis le : </strong></label>
                </b-col>
                <b-col sm="3">
                  <b-form-input class="input_date" type="date" id="date_rentes_transmis" size="sm" v-model="date_rentes_transmis"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col sm="2">
                  <label for="allocations"><strong>Allocations : </strong></label>
                </b-col>
                <b-col sm="5">
                  <multiselect id="allocations" selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false" v-model="allocations" tag-placeholder="Choisissez un status" placeholder="Par défaut Tous" label="name" track-by="code" :options="allocationsOptions" :multiple="true" :taggable="true"></multiselect>
                </b-col>
                <b-col sm="2">
                  <label for="date_allocations_transmis"><strong>Transmis le : </strong></label>
                </b-col>
                <b-col sm="3">
                  <b-form-input class="input_date" type="date" id="date_allocations_transmis" size="sm" v-model="date_allocations_transmis"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col sm="2">
                  <label for="statut_beneficiaire"><strong>Statut bénéficiaire</strong></label>
                </b-col>
                <b-col sm="5">
                  <b-form-select v-model="selectedStatus" :options="statusOption">
                    <template v-slot:first>
                      <b-form-select-option :value="''" disabled>-- Choisir le statut du dossier du bénéficiaire --</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label for="date_status"><strong>Màj le : </strong></label>
                </b-col>
                <b-col sm="3">
                  <b-form-input class="input_date" type="date" id="date_status" size="sm" v-model="date_status"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-1" v-if="infosRelance">
                <b-col sm="2">
                  <label for="statut_beneficiaire"><strong>Relance</strong></label>
                </b-col>
                <b-col sm="5">
                  <b-form-select v-model="typeRelance">
                    <b-form-select-option value=""><i>-- Choisissez le type de relance --</i></b-form-select-option>
                    <b-form-select-option value="relance_1">Relance 1</b-form-select-option>
                    <b-form-select-option value="relance_2">Relance 2</b-form-select-option>
                    <b-form-select-option value="relance_3">Relance 3</b-form-select-option>
                    <b-form-select-option value="relance_anuelle">Relance anuelle</b-form-select-option>
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label for="date_status"><strong>Date envoi : </strong></label>
                </b-col>
                <b-col sm="3">
                  <b-form-input class="input_date" type="date" id="date_envoi" v-model="dateEnvoiRelance"></b-form-input>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <button type="button" @click="save()" class="btn btn-primary float-right"><i class="fa fa-save"></i>
                Enregistrer
              </button>
              <button type="button" class="btn btn-secondary mr-2 float-right" @click="closeInfoBeneficiaire()">Annuler</button>
            </b-col>
          </b-row>
          <!-- pj du bénéficiaire et complétude dossier -->
          <b-row>

          </b-row>
        </b-card-text>
      </b-collapse>

    </b-card>
  </div>
</template>
<script>
  import { isEmpty } from '@/utils/fileHelper';
  import { formatDate, cantEditFicheDC } from '@/utils/communHelper';
  import Multiselect from 'vue-multiselect';

  export default {
    name: 'Beneficiaire',
    props: [
      'dossier',
      'traitements'
    ],
    components: {
      Multiselect
    },
    data() {
      return {
        isEmpty,
        formatDate,
        collapseInfosBeneficiaire: true,
        showCardInfosBeneficiaire: false,
        beneficiaireId: null,
        nom: '',
        prenom: '',
        date_naissance: '',
        selectedLienParente: '',
        adresse1: '',
        adresse2: '',
        adresse3: '',
        cp: '',
        ville: '',
        email: '',
        telephone: '',
        allLienParente: '',
        lienParenteOptions: [],
        capitalDeces: [],
        selectedCapital: [],
        date_capital_deces_transmis: '',
        rentes: [],
        selectedRentes: [],
        date_rentes_transmis: '',
        allocations: [],
        selectedAllocations: [],
        date_allocations_transmis: '',
        date_status: '',
        selectedStatus: '',
        allStatusBeneficiaire: [],
        statusOption: [],
        relanceOptions: [
          { code: 'relance_1', name: 'Relance 1' },
          { code: 'relance_2', name: 'Relance 2' },
          { code: 'relance_3', name: 'Relance 3' },
          { code: 'relance_annuelle', name: 'Relance annuelle' },
        ],
        capitalOptions: [
          {code: 'has_capital', name: 'Capital'},
          // {code: 'has_capital_sup_75', name: 'Capital > 75k€ Mutex'},
          {code: 'has_capital_sup_150', name: 'Capital > 150k€ validation direction'},
          {code: 'has_capital_orphelin', name: 'Capital orphelin'},
          {code: 'has_maloration_personne_a_charge', name: 'Majoration personne à charge'},
          {code: 'has_maloration_accident', name: 'Majoration Accident'},
        ],
        rentesOptions: [
          {code: 'has_rente_conjoint', name: 'Rente Conjoint/Viagère'},
          {code: 'has_rente_education', name: 'Rente Education'},
          {code: 'has_rente_temporaire', name: 'Rente temporaire'},
          {code: 'has_rente_ocirp', name: 'Rente OCIRP gérée par Mutex'},
          {code: 'has_rente_viagere_orphelin', name: 'Rente viagère orphelin'},
          {code: 'has_rente_viagere_handicap', name: 'Rente viagère handicap'},
        ],
        allocationsOptions: [
          {code: 'has_allocation_obseque', name: 'Allocations Obsèques'},
        ],
        errors: {
          nom: '',
          prenom: '',
          selectedLienParente: '',
        },
        columns: [
          'nom',
          'prenom',
          'date_naissance',
          'lien_parente',
          'capital_deces',
          'date_capital_deces_transmis',
          'rentes',
          'date_rentes_transmis',
          'allocations',
          'date_allocations_transmis',
          'status',
          'date_status',
          'action'
        ],
        items: [],
        options: {
          headings: {
            nom: 'Nom',
            prenom: 'Prénom',
            date_naissance: 'Date de\nnaissance',
            lien_parente: 'Lien de\nparenté',
            capital_deces: 'Capital décès',
            date_capital_deces_transmis: 'Transmis le',
            rentes: 'Rentes',
            date_rentes_transmis: 'Transmis le',
            allocations: 'Allocations',
            date_allocations_transmis: 'Transmis le',
            status: 'Statut',
            date_status: 'Date Statut',
            action: 'Action'
          },
          columnsClasses: {
            lien_parente: '',
            date_naissance: ' date-header',
            date_capital_deces_transmis: 'date-header',
            date_rentes_transmis: 'date-header',
            date_allocations_transmis: 'date-header',
            action: 'action-xs'
          },
          rowClassCallback(row) {
            // if(row.is_active == false){
            //   return "desactive";
            // }else if(row.profil_active[0] == undefined && row.profil_futur != undefined){
            //   return "inactive";
            // }

          },
          filterByColumn: false,
          sortable: [],
          filterable: [],
          perPage: 10,
          perPageValues: [10, 50, 500],
          texts: {
            filterPlaceholder: "Nom, Prénom, Email"
          },
          orderBy: { column: "created_at", ascending: false }
        },
        piecesJointes: [],
        infosRelance: false,
        typeRelance: '',
        dateEnvoiRelance: null
      }
    },
    watch: {
      capitalDeces() {
        if (this.capitalDeces) {
          this.selectedCapital = this.capitalDeces.map( item => item.code);
        } else {
          this.selectedCapital = [];
        }
      },
      rentes() {
        if (this.rentes) {
          this.selectedRentes = this.rentes.map( item => item.code);
        } else {
          this.selectedRentes = [];
        }
      },
      allocations() {
        if (this.allocations) {
          this.selectedAllocations = this.allocations.map( item => item.code);
        } else {
          this.selectedAllocations = [];
        }
      },
      dossier() {
        this.items = !isEmpty(this.dossier.deces_beneficiaire) ? this.dossier.deces_beneficiaire : [];
      }
    },
    created() {
      this.getAllStatusBeneficiaire();
      this.getAllLienParente();
      this.items = !isEmpty(this.dossier.deces_beneficiaire) ? this.dossier.deces_beneficiaire : [];
      this.piecesJointes = this.dossier.pieces_jointes;

      this.$event.on('changementPj', piecesJointes => {
        this.piecesJointes = piecesJointes;
      });
    },
    methods: {
      isDisabled(field) {
        return this.$parent.$parent.$parent.isDisabled(field);
      },
      initiateAddBeneficiaire() {
        // this.$refs['modal-add-beneficiaire'].show();
        this.clearForm();
        this.clearErrors();
        this.showCardInfosBeneficiaire = true;
        this.infosRelance = false
      },
      editBeneficiaire(beneficiaire) {
        // this.$refs['modal-add-beneficiaire'].show();
        this.clearForm();
        this.clearErrors();

        this.beneficiaireId = beneficiaire.id;
        this.nom = beneficiaire.nom;
        this.prenom = beneficiaire.prenom;
        this.date_naissance = beneficiaire.date_naissance;
        this.selectedLienParente = beneficiaire.lien_parente_id;
        this.adresse1 = beneficiaire.adresse1;
        this.adresse2 = beneficiaire.adresse2;
        this.adresse3 = beneficiaire.adresse3;
        this.cp = beneficiaire.cp;
        this.ville = beneficiaire.ville;
        this.email = beneficiaire.email;
        this.telephone = beneficiaire.telephone;

        this.date_capital_deces_transmis = beneficiaire.date_capital_deces_transmis;
        if (!isEmpty(beneficiaire.capital)) {
          for (let capital of this.capitalOptions) {
            if (beneficiaire.capital.indexOf(capital.code) > -1) { this.capitalDeces.push(capital) }
          }
        }

        this.date_rentes_transmis = beneficiaire.date_rentes_transmis;
        if (!isEmpty(beneficiaire.rentes)) {
          for (let rente of this.rentesOptions) {
            if (beneficiaire.rentes.indexOf(rente.code) > -1) { this.rentes.push(rente) }
          }
        }

        this.date_allocations_transmis = beneficiaire.date_allocations_transmis;
        if (!isEmpty(beneficiaire.allocations)) {
          for (let allocation of this.allocationsOptions) {
            if (beneficiaire.allocations.indexOf(allocation.code) > -1) { this.allocations.push(allocation) }
          }
        }

        this.date_status = beneficiaire.date_status;
        this.selectedStatus = beneficiaire.status_id;

        this.showCardInfosBeneficiaire = true;

        this.infosRelance = true
        this.typeRelance = beneficiaire.type_relance
        this.dateEnvoiRelance = beneficiaire.date_envoi_relance
      },
      save() {
        this.clearErrors();
        if (this.validateBeneficiaire()) {
          let self = this;
          let dataPost = {
            traitementId: parseInt(this.$route.query.traitementId),
            beneficiaire_id: this.beneficiaireId,
            dossier_id: this.dossier.id,
            nom: this.nom,
            prenom: this.prenom,
            date_naissance: this.date_naissance,
            lien_parente_id: this.selectedLienParente,
            adresse1: this.adresse1,
            adresse2: this.adresse2,
            adresse3: this.adresse3,
            cp: this.cp,
            ville: this.ville,
            email: this.email,
            telephone: this.telephone,
            selectedCapital: this.selectedCapital,
            date_capital_deces_transmis: this.date_capital_deces_transmis,
            selectedRentes: this.selectedRentes,
            date_rentes_transmis: this.date_rentes_transmis,
            selectedAllocations: this.selectedAllocations,
            date_allocations_transmis: this.date_allocations_transmis,
            status_id: this.selectedStatus,
            date_status: this.date_status,
            type_relance: this.typeRelance,
            date_envoi_relance: this.dateEnvoiRelance
          };
          this.$axios
            .post(`/espaceGestion/dossier/beneficiaire-deces/save`, dataPost)
            .then(async response => {
              // console.log('autocomplete data', response.data.data)
              // this.closeModalAddBeneficiaire();
              this.clearForm();
              this.showCardInfosBeneficiaire = false;
              // On enregistre les éventuels changement fait dans les autres component avant de refresh le dossier
              await this.$parent.$parent.$parent.save('save');
              this.$event.emit('refreshDossier');
            })
            .catch(function (error) {
              console.log(error);
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue lors de la récupération de la liste des liens de parenté, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              })
            })
        }
      },
      getAllLienParente() {
        let self = this;
        this.$axios
          .get(`/espaceGestion/lien-parente/all`)
          .then(response => {
            // console.log('autocomplete data', response.data.data)
            this.allLienParente = response.data.liens_parente;
            for (let lien of response.data.liens_parente) {
              this.lienParenteOptions.push({text: lien.libelle, value: lien.id});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la récupération de la liste des liens de parenté, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            })
          })
      },
      getAllStatusBeneficiaire() {
        let self = this;
        this.$axios
          .get(`/administration/beneficiaire-deces-status/all`)
          .then(response => {
            // console.log('autocomplete data', response.data.data)
            this.allStatusBeneficiaire = response.data.status;
            for (let status of response.data.status) {
              this.statusOption.push({text: status.libelle_bo, value: status.id});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la récupération de la liste des liens de parenté, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            })
          })
      },
      // isTreatment(libelle_technique) {
      //   let treatment = _.find(this.traitements, (element) => element.libelle_technique === libelle_technique );
      //   return isEmpty(treatment) ? false : parseInt(this.$route.query.traitementId,10) === treatment.id;
      // },
      closeInfoBeneficiaire() {
        this.clearForm();
        this.clearErrors();
        this.showCardInfosBeneficiaire = false;
      },
      clearForm() {
        this.beneficiaireId = null;
        this.nom = '';
        this.prenom = '';
        this.date_naissance = '';
        this.selectedLienParente = '';
        this.adresse1 = '';
        this.adresse2 = '';
        this.adresse3 = '';
        this.cp = '';
        this.ville = '';
        this.email = '';
        this.telephone = '';
        this.capitalDeces = [];
        this.date_capital_deces_transmis = '';
        this.rentes = [];
        this.date_rentes_transmis = '';
        this.allocations = [];
        this.date_allocations_transmis = '';
        this.selectedStatus = '';
        this.date_status = '';
      },
      validateBeneficiaire() {
        let valid = true;

        if (isEmpty(this.nom)) {
          this.errors.nom = 'Vous devez saisir le nom du bénéficiaire.';
          valid = false;
        }
        if (isEmpty(this.prenom)) {
          this.errors.prenom = 'Vous devez saisir le prénom du bénéficiaire.';
          valid = false;
        }
        // if (isEmpty(this.selectedLienParente)) {
        //   this.errors.selectedLienParente = 'Vous devez choisir le lien de parenté.';
        //   valid = false;
        // }
        return valid;
      },
      clearErrors() {
        this.errors.nom = '';
        this.errors.prenom = '';
        this.errors.selectedLienParente = '';
      },
      deleteBeneficiaire(beneficiaireId) {
        let text = 'Voulez-vous supprimer ce bénéficiaire ?';
        if (this.hasAttachedPj(beneficiaireId)) {
          text = 'Voulez-vous vraiment supprimer ce bénéficiaire bien que des pièces jointes lui soient rattachées ?'
        }
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: text,
            type: 'warning',
            reverseButtons: false,
            showCancelButton: true,
            cancelButtonColor: '#ff1744',
            confirmButtonText: 'Supprimer',
            cancelButtonText: 'Annuler',
          })
          .then((result) => {
            if(!isEmpty(result.value)){
              let self = this;
              this.$axios
                .delete(`/espaceGestion/dossier/beneficiaire-deces/delete/`+beneficiaireId+'/'+this.$route.query.traitementId)
                .then(async response => {
                  // console.log('autocomplete data', response.data.data)
                  // On enregistre les éventuels changement fait dans les autres component avant de refresh le dossier
                  await this.$parent.$parent.$parent.save('save');
                  this.$event.emit('refreshDossier');
                })
                .catch(function (error) {
                  console.log(error);
                  let text = 'Une erreur est survenue lors de la suppression du bénéficiaire, si le problème persiste merci de faire un ticket au support DOSI';
                  if (!isEmpty(error) && error.response && error.response.status === 424) {
                    text = error.response.data.message;
                  }
                  self.$swal({
                    position: 'top',
                    type: 'error',
                    title: 'Attention !!',
                    text: text,
                    showConfirmButton: false,
                    timer: 5000
                  })
                })
            }
          });
      },
      getStatusLibelle(beneficiaire) {
        let status = this.allStatusBeneficiaire.find(status => status.id === beneficiaire.status_id);
        return !isEmpty(status) ? status.libelle_bo : '';
      },
      getCapitalDecesLibelle(beneficiaire) {
        let libelle = '';
        if (!isEmpty(beneficiaire.capital)) {
          for (let capital of this.capitalOptions) {
            if (beneficiaire.capital.indexOf(capital.code) > -1) {
              libelle = libelle + capital.name + ' <b>|</b> ';
            }
          }
        }
        return libelle.replace(/ <b>\|<\/b> $/, '');
      },
      getRentesLibelle(beneficiaire) {
        let libelle = '';
        if (!isEmpty(beneficiaire.rentes)) {
          for (let rente of this.rentesOptions) {
            if (beneficiaire.rentes.indexOf(rente.code) > -1) {
              libelle = libelle + rente.name + ' <b>|</b> ';
            }
          }
        }
        return libelle.replace(/ <b>\|<\/b> $/, '');
      },
      getAllocationsLibelle(beneficiaire) {
        let libelle = '';
        if (!isEmpty(beneficiaire.allocations)) {
          for (let allocation of this.allocationsOptions) {
            if (beneficiaire.allocations.indexOf(allocation.code) > -1) {
              libelle = libelle + allocation.name + ' <b>|</b> ';
            }
          }
        }
        return libelle.replace(/ <b>\|<\/b> $/, '');
      },
      hasAttachedPj(beneficiaireId) {
        let find = false;
        for (let pj of this.piecesJointes) {
          for (let beneficiaire of pj.beneficiares_deces) {
            if (parseInt(beneficiaire.id,10) === parseInt(beneficiaireId,10)) {
              find = true;
              break;
            }
          }
        }
        return find;
      },
      cantEditFicheDC
    }
  }
</script>
<style type="text/css">
  #table-beneficiaire .table-responsive table thead tr th {
    padding: 0 0.75rem;
  }
  #table-beneficiaire .table thead th.date-header {
    width: auto;
  }
</style>
